import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthenticationService } from "src/app/helpers/auth.services";
import { SharedService } from "src/app/shared/shared.service";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: "app-microsoft-callback",
  template: `<div style="display:flex;align-items:center;justify-content:center;height:100vh;">
               <p>Signing you in...</p>
             </div>`,
})
export class MicrosoftCallbackComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private sharedService: SharedService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const code = params["code"];
      const error = params["error"];

      if (error) {
        this.snackBar.open("Microsoft sign-in failed. Please try again.", "X", {
          duration: 5000,
          panelClass: ["if-error"],
        });
        this.router.navigate(["/login"]);
        return;
      }

      if (code) {
        // Send the code to YOUR backend to exchange it with Microsoft
        this.authenticationService.loginWithMicrosoft(code).subscribe(
          (data: any) => {
            const user = data;
            this.snackBar.open("Login Successfully", "", {
              duration: 3000,
              panelClass: ["if-success"],
            });
            this.getpermissionDetails(user.roleId);
            this.getModulepermissionDetails(user.roleId);
            this.router.navigate(["/"]);
          },
          (err) => {
            this.snackBar.open("Sign-in failed. Please try again.", "X", {
              duration: 5000,
              panelClass: ["if-error"],
            });
            this.router.navigate(["/login"]);
          }
        );
      } else {
        this.router.navigate(["/login"]);
      }
    });
  }

  getpermissionDetails(id) {
    this.sharedService.getPermissionyDetailsById(id).subscribe({
      next: (response) => {
        localStorage.setItem("PermissionDetails", JSON.stringify(response));
        for (let i = 0; i < response.length; i++) {
          const moduleName = response[i].moduleName;
          localStorage.setItem(moduleName + "AddAccess", response[i].addAccess);
          localStorage.setItem(moduleName + "EditAccess", response[i].editAccess);
          localStorage.setItem(moduleName + "ViewAccess", response[i].viewAccess);
        }
      },
    });
  }

  getModulepermissionDetails(role) {
    this.sharedService.getModulePermssionByRoles(role).subscribe({
      next: (response: any) => {
        localStorage.setItem("Module_PermissionDetails", JSON.stringify(response));
        for (let i = 0; i < response.data.length; i++) {
          const moduleName = response.data[i].moduleName;
          localStorage.setItem(moduleName + "MenuAccess", response.data[i].visible);
          const submodule = response.data[i].subModules;
          for (let j = 0; j < submodule.length; j++) {
            localStorage.setItem(submodule[j].subModuleName + "MenuAccess", submodule[j].subVisible);
          }
        }
      },
    });
  }
}